import { StepAction } from "./Actions";
import { StepState } from "./Reducer";

export function handleSetStepAction(state: StepState, action: StepAction<any>) {
    const { step } = action.payload;
    return {
        ...state,
        step: step,
    };
}
